import { Drawer, DrawerContent } from '@vta/ui';
import { useSelectedTeamStore } from '../../stores/selected-team-store.ts';
import { useMediaQuery } from '../../lib/useMediaQuery.ts';
import { TeamDrawerBody } from '../../features/teams/TeamDrawerBody.tsx';
import { CityDrawerBody } from '../../features/cities/CityDrawerBody.tsx';

/**
 * Mobile bottom-sheet wrapper. Same selection store and the same drawer
 * bodies as the desktop right-drawer — only the presentation (bottom sheet,
 * drag handle, scale-background) differs. Only rendered below `md` so the
 * dual-mounting on desktop does not produce two drawers.
 */
export function MobileSheet() {
  const isOpen = useSelectedTeamStore((s) => s.isOpen);
  const selection = useSelectedTeamStore((s) => s.selection);
  const close = useSelectedTeamStore((s) => s.close);
  const isDesktop = useMediaQuery('(min-width: 768px)');

  if (isDesktop) return null;

  return (
    <Drawer
      open={isOpen}
      onOpenChange={(next) => {
        if (!next) close();
      }}
      direction="bottom"
      dismissible
    >
      <DrawerContent side="bottom">
        {selection.kind === 'team' ? (
          <TeamDrawerBody teamNumber={selection.teamNumber} />
        ) : selection.kind === 'city' ? (
          <CityDrawerBody
            citySlug={selection.citySlug}
            fallbackCity={selection.city}
            fallbackCountry={selection.country}
          />
        ) : null}
      </DrawerContent>
    </Drawer>
  );
}
